// A product list's position is remembered per list — path and query (tab, filter, search) — so it can only ever
// come back to the list it was saved on.
export function listScrollKey(location = window.location) {
  return `scroll:${location.pathname}${location.search}`
}

// Saved on opening a card: the scroll offset plus the card (href) and where it sat on screen, so the return can
// put that card back in the same spot even if the list above it grew or shrank.
export function saveListScroll(card, storage = window.sessionStorage, location = window.location) {
  const entry = { y: Math.round(window.scrollY) }
  const href = card?.getAttribute?.("href")
  if (href) Object.assign(entry, { href, top: Math.round(card.getBoundingClientRect().top) })
  try {
    storage.setItem(listScrollKey(location), JSON.stringify(entry))
  } catch {
    // private mode: Turbo's own restore still applies
  }
}

// Read and forget the entry saved for the current list (null when none).
export function takeListScroll(storage = window.sessionStorage, location = window.location) {
  try {
    const key = listScrollKey(location)
    const saved = storage.getItem(key)
    if (saved === null) return null
    storage.removeItem(key)
    const entry = JSON.parse(saved)
    return typeof entry === "number" ? { y: entry } : { y: Number(entry.y) || 0, href: entry.href, top: entry.top }
  } catch {
    return null
  }
}

// Where to scroll: keep the opened card at its old screen offset when it is on the page, else the saved offset.
export function listScrollTarget(entry, { scrollY = 0, anchorTop = null } = {}) {
  if (anchorTop === null || entry.top === undefined || entry.top === null) return entry.y
  return Math.max(0, Math.round(scrollY + anchorTop - entry.top))
}

export function restoreListScroll(entry, root = document) {
  const anchor = entry.href ? root.querySelector(`#products-grid a[href="${CSS.escape(entry.href)}"]`) : null
  window.scrollTo(0, listScrollTarget(entry, { scrollY: window.scrollY, anchorTop: anchor ? anchor.getBoundingClientRect().top : null }))
}
